import { InputTypes, ValidatorTypes } from '@cashier/cashier-model';

import { FieldCollector } from '../model';

export const FileUploadFieldCollector: FieldCollector = {
  collect: (formSchema, field) => {
    formSchema.fileUploadField ??= {
      ...field,
      validatorType: ValidatorTypes.COMMON,
    };
  },
  shouldCollect: (field) => {
    return field.type === InputTypes.FileLink;
  },
};
